import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutModule } from '@angular/cdk/layout';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NeoBaseComponent } from '@app/shared/components/base/neo-base.component';
import { NeoTrackEventAction, NeoTrackEventComponent, NeoTrackEventLocation, NeoTrackEventStatus } from '@app/services/amplitude.service.models';

@Component({
    selector: 'neo-page-not-found',
    imports: [
        RouterModule,
        LayoutModule,
        MatIconModule,
        MatButtonModule
    ],
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.scss'
})
export class PageNotFoundComponent extends NeoBaseComponent implements OnInit {
  constructor() {
    super();
  }

  public ngOnInit(): void {
    this.amplitudeService.track(NeoTrackEventAction.View, NeoTrackEventComponent.App, NeoTrackEventLocation.PageNotFound, NeoTrackEventStatus.None);
    this.neoLogService.log('Page Not Found');
  }
}
